import NewTabLink from './NewTabLink';

export default NewTabLink;
